<template>
  <div>
    <footer>
      <div class="moveP">
        <div class="move">
          <img src="../assets/wave.png" alt="" />
          <img src="../assets/wave.png" alt="" class="one"/>
          <img src="../assets/wave.png" alt="" class="two"/>
          <img src="../assets/wave.png" alt="" />
        </div>
      </div>
      <main>
        <div class="mascot3">
          <img src="../assets/home_mascot3.png" alt="" />
        </div>
        <div class="foot-content container">
          <div class="section1">
            <div class="foot-sec foot-left">
              <div class="title">客服帮助</div>
              <div class="intro1">400-991-8857</div>
            </div>
            <div class="foot-sec">  
              <div class="title">商务合作</div>
              <div class="intro">htx556@126.com</div>
            </div>
            <div class="idea">
              我们希望与广大商务合作伙伴、渠道合作伙伴、媒体与自媒体朋友一起，
              拓展出全新的营销及合作模式来创造品牌社会效益和经济效益的共赢。
            </div>
          </div>
          <div class="section2">
            <div class="address foot-left">
              <p>地址:山东省潍坊市潍城区好希望大厦9楼</p>
              <p>山东画天才网络科技有限公司</p>
            </div>
            <div class="foot-sec">
              <div class="title">内容版权合作</div>
              <div class="intro">htx556@126.com</div>
            </div>
          </div>
          <div class="foot-tip">
            山东画天才网络科技有限公司&nbsp;&nbsp;All Rights Reserved&nbsp;&nbsp;<a target="_black" href="https://beian.miit.gov.cn/">鲁ICP备2022014676号-1</a>&nbsp;&nbsp;经营许可证：<a target="_black" href="https://dxzhgl.miit.gov.cn/dxxzsp/xkz/xkzgl/resource/qiyesearch.jsp?num=%25E9%25B2%2581B2-20221005&type=xuke">鲁B2-20221005</a>
          </div>
        </div>
      </main>
    </footer>
  </div>
</template>

<script>
export default {
  name: "Foot",
};
</script>

<style lang="scss">
footer {
  position: relative;
  margin-top: -2.35%;
  z-index: 10;
  .moveP {
    overflow-x: hidden;
    // width: 100%;
    .move {
      display: flex;
      animation-duration: 10s;
      animation-name: slide-left2;
      animation-timing-function: linear;
      animation-iteration-count: infinite;
      .one, .two {
        margin: 0 -2px;

      }
    }

  }

  

  main {
    background: #2a2369;

    .mascot3 {
      width: 12.6%;
      position: absolute;
      top: -110px;
      left: 47%;
      transform: translateX(-50%);
      animation-duration: 1.2s;
      animation-name: move10;
      animation-timing-function: ease-in-out;
      animation-iteration-count: infinite;
      z-index: 1000;
    }

    .foot-content {
      padding: 20px 0 13px 103px;

      .section1 {
        margin-bottom: 50px;
        display: flex;

        .intro1 {
          font-size: 36px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ffffff;
          line-height: 34px;
        }

        .idea {
          width: 581px;
          font-size: 18px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #f2f2f2;
          line-height: 34px;
          margin-left: 43px;
        }
      }

      .section2 {
        display: flex;

        .address {
          height: 30px;
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ffffff;
          line-height: 34px;
          margin-top: 6px;
        }
      }

      .foot-sec {
        .title {
          font-size: 36px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ffffff;
          line-height: 34px;
          margin-bottom: 10px;
        }

        .intro {
          font-size: 21px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ffffff;
          line-height: 34px;
        }
      }

      .foot-left {
        width: 355px;
        flex-shrink: 0;

        .title {
          margin-bottom: 31px;
        }
      }

      .foot-tip {
        height: 44px;
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #c8c8c8;
        line-height: 34px;
        text-align: center;
        padding-bottom: 20px;
        margin-top: 102px;
        a {
          text-decoration: none;
        }
      }
    }
  }
}
</style>